export default {
  title: 'Pikatoiminnot',
  send_push_notification: {
    label: 'Lähetä push-ilmoitus',
    description: 'Luo uusi kampanja',
  },
  email_campaign: {
    label: 'Sähköpostikampanja',
    description: 'Lähetä tilaajille',
  },
  view_analytics: {
    label: 'Näytä analytiikka',
    description: 'Kampanjan suorituskyky',
  },
};
